import React from 'react'
import SweetAlert from 'sweetalert-react';
import 'sweetalert/dist/sweetalert.css'
import { Button } from '@material-ui/core';
import { css } from "@emotion/core";
import DotLoader from "react-spinners/DotLoader"

const override = css`
  display: block;
  margin: 0 auto;
`;

class ProgressBar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            check: false
        }
    }
    componentDidMount = () => {
        this.props.handleSubmit();
    }

    render() {
        return (
            <div style={{ textAlign: "center", padding: "40px 0", height: 450 }}>
                {
                    this.state.loading === false ?
                        <h1 style={{ color: "red" }}>Upload Failed!!</h1> :
                        <div>
                            <h2>Please be patient ...</h2>
                            <div className="sweet-loading" style={{ marginTop: 30 }}>
                                <DotLoader
                                    css={override}
                                    size={100}
                                    color={"#000"}
                                    loading={this.state.loading}
                                />
                            </div>
                        </div>
                }

                {
                    this.state.loading === false ?
                        <div style={{ marginTop: 30 }}>
                            <Button onClick={this.props.handleBack} >
                                Go Back
                                </Button>

                        </div> : ""
                }
                <SweetAlert
                    show={this.props.alert.show}
                    type={this.props.alert.type}
                    title={this.props.alert.title}
                    text={this.props.alert.text}
                    onConfirm={() => {
                        if (this.props.alert.type === "success") {
                            localStorage.clear();
                            window.location.reload();
                        } else {
                            this.setState({
                                loading: false
                            })
                            this.props.setAlert({
                                ...alert,
                                show: false
                            })
                        }
                    }}
                />
            </div>

        )
    }
}

export default ProgressBar;